<template>
  <div class="app-container calendar-list-container">
    <el-row>
      <!-- <el-col :span="5">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>部门名称</span>
          </div>
          <el-tree class="filter-tree" :data="treeData" node-key="id" highlight-current :props="defaultProps" :filter-node-method="filterNode" @node-click="getNodeData" default-expand-all>
          </el-tree>
        </el-card>
      </el-col> -->
      <el-col :span="24">
        <el-card class="box-card">
          <avue-crud :data="treeData" :option="tableOption" @current-row-change="handleCurrentRowChange" @row-click="showRow">
            <template slot-scope="scope" slot="menuLeft">
              <el-button v-if="sys_dept_add" size="mini" class="filter-item" @click="AddElement" type="primary" icon="el-icon-plus">添加
              </el-button>
              <el-button v-if="sys_dept_edit" size="mini" class="filter-item" @click="updateElement" type="primary"  icon="el-icon-edit-outline"  :disabled = "totalStatus">编辑
              </el-button>
              <el-button v-if="sys_dept_del" size="mini" class="filter-item"  @click="handleDelete" type="primary" icon="el-icon-edit-outline"  :disabled = "totalStatus">删除
              </el-button>
            </template>
            <!-- <template slot-scope="scope" slot="id">
                <el-radio class="radio" v-model="radio" :label="scope.row.id"></el-radio>
            </template> -->
          </avue-crud>
        </el-card>
      </el-col>
    </el-row>
    <!-- 添加 -->
    <edit ref="child" @refresh="refresh"></edit>
  </div>
</template>

<script>
  import { fetchDept, getObj, addObj, delObj, putObj,getchild } from '@/api/admin/dept'
  import { mapGetters } from 'vuex'
  import { objKeySort } from '@/util/ajaxsign'
  import edit from './edit.vue'
  export default {
    components: {edit},
    data() {
      return {
        permissions : [],
        totalStatus : true,
        radio:'',
        parentId:'',
        cid:'',
        name : '',
        deptList: [],
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        sys_dept_del : false,
        sys_dept_edit : false,
        sys_dept_add : false,
        tableOption : {
          addBtn : false,
          refreshBtn : false,
          columnBtn : false,
          editBtn : true,
          delBtn : true,
          menu : false,
          page:true,
          border : true,
          expandAll: false,
          expandLevel: 2,
          border: true,
          index: true,
          tree:true,
          highlightCurrentRow:true,
          align:'center',
          menuAlign:'center',
          height : window.innerHeight - 290,
          index:false,
          column:[
          // {
          //     label:'',
          //     prop:'id',
          //     width:40,
          //     solt:true
          // },
          {
              label:'部门名称',
              prop:'name'
          },
          {
              label:'部门人数',
              prop:'employeeCount'
          },
          {
              label:'描述',
              prop:'tips'
          },
          {
              label:'时间',
              prop:'createTime',
              overHidden : true,
              type: 'date',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss'
          }
          ]
        }
      }
    },
    created() {
      this.getList()
      this.permissions = JSON.parse(window.sessionStorage.getItem("userInfo")).permissions;
      for(var i=0;i<this.permissions.length;i++){
        if(this.permissions[i] == 'sys_dept_add'){
          this.sys_dept_add = this.permissions[i]
        }
        if(this.permissions[i] == 'sys_dept_edit'){
          this.sys_dept_edit = this.permissions[i]
        }
        if(this.permissions[i] == 'sys_dept_del'){
          this.sys_dept_del = this.permissions[i]
        }
      }
    },
    methods: {
      //刷新列表操作
      refresh(data){
        this.totalStatus=true;
        this.getList();
        this.radio = undefined;
      },

      showRow(row,event){
        this.radio = row.id;
        this.parentId = row.parentId;
        this.cid = row.id?row.id:row.deptId;
        this.tips=row.tips
        this.totalStatus=false;
      },

      //点击显示增加
      AddElement(){
        this.$refs.child.dialog('create',this.cid,this.name);
      },

      // 点击显示修改
      updateElement(){
        this.$refs.child.updialog('update',this.cid,this.parentId,this.tips);
      },

      //获取部门树结构
      getList() {
        fetchDept(objKeySort({})).then(response => {
          this.treeData = response.data.data
        })
      },

       handleCurrentRowChange(val){

        },

      filterNode(value, data) {
        if (!value) return true
        return data.label.indexOf(value) !== -1
      },
      getNodeData(data) {
        this.deptList = []
        this.cid = data.id;
        this.name = data.name;
        this.parentId = data.parentId;
        this.totalStatus = false;
        var dept_id = data.id;
        var arr ='';
        for(var i=0; i<this.treeData.length;i++){
          if(dept_id == this.treeData[i].id){
            arr=this.treeData[i].children
          }
        }
        getchild(objKeySort({parentId:data.id})).then(response => {
          this.deptList = arr=response.data.data
        })
      },

      //删除部门
      handleDelete() {
        this.$confirm('此操作将永久删除此部门, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 点击当前部门信息并删除
          delObj(objKeySort({id:this.cid})).then(() => {
            this.getList()
            this.$message({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000
            })
          })
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
    .el-table{
    margin-top:22px;
}
.el_s_left{
    float:left
}
.el_btn{
    clear:both;
}

.filter-item1{
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0!important;
    margin-left: 0!important;
    margin-right: 22px;
  }

  .sh_tip{
      vertical-align:top;
      display:inline-block
  }
  .lf_item span:first-child{
      display:inline-block;
      width:100px;
      vertical-align:top;
  }
  .el-form-items{
    float: left;
    width: 48%!important;
  }
  .el-form-itemss{
    width: 300px!important;
    height: 40px!important;
    background-attachment: #fff!important;
  }
  .el-form-itemss .el-input{
    outline: none!important;
  }
  .el-f-item{
    width: 100%!important;
  }
  .el-dialog__header{
    margin-bottom: 25px;
  }
  .el-tag{
    border: 0!important;
    color: #666!important;
    background-color: transparent;
    font-size:14px;
  }
  .dialog-footer{
    margin-left: 0!important;
  }
  .filter-item1{
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0!important;
    margin-left: 0!important;
    margin-right: 22px;
  }

  .is-required{
    width:48%;
    float:left;
  }
  /*.select_role{
    -height:100px;
  }*/
  .el-dialog__footer{
    -height:120px;
  }
  .p1{
    width:100% !important;
  }
  .part{
    position: relative;
  }
/*.el-table /deep/ .el-radio{

  }*/
  .el-table /deep/ .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }

</style>
